import $ from 'jquery';
import _ from 'underscore';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import StateManager from '../scuba/StateManager';

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function(event, node) {
    $(node).find('.js-content').each(function(i, el) {
        new Content(el);
    });
});


/* --------------------------------------------------

    CLASS

-------------------------------------------------- */

function Content() {
    this.initialize.apply(this, arguments);
}

$.extend(Content.prototype, {

    initialize: function(el) {
      var self = this;
      self.uid = _.uniqueId('scuba-');
      self.$el = $(el);
      self.$images = self.$el.find(".js-content__image");
      var pswpElement = document.querySelectorAll('.pswp')[0];

      // build items array
      var items = [];

      self.$images.each(function(index, image) {
        var $img = $(image);
        items.push({
          src: $img.attr("data-full-src"),
          msrc: $img.attr("src"),
          w: parseInt($img.attr("data-full-width")),
          h: parseInt($img.attr("data-full-height")),
          title: $img.attr("alt"),
          description: $img.attr("data-description"),
        });
      });

      self.$images.on('click', function(event) {
        event.preventDefault();
        var $index = self.$images.index(this);
        var options = {
          index: $index,
          addCaptionHTMLFn: function(item, captionEl) {
            if(!item.title) {
              captionEl.children[0].innerText = '';
              return false;
            }
            captionEl.children[0].innerHTML = item.title +  '<br/><small>' + item.description + '</small>';
            return true;
          },
        }
        var lightBox = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        lightBox.init();
      });
    },

});



// WEBPACK FOOTER //
// ./scripts/components/Content.js